import { render, staticRenderFns } from "./ChatMenu.vue?vue&type=template&id=4c1803d0&scoped=true"
import script from "./ChatMenu.vue?vue&type=script&lang=js"
export * from "./ChatMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatMenu.vue?vue&type=style&index=0&id=4c1803d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1803d0",
  null
  
)

export default component.exports